import axios from "axios";
import { t } from "i18next";

import AlertsService from "services/alerts-service";

import { putStorage } from "hooks/useStorage";

const ReviewsAPI = {
    getAllReviews: async () => {
        try {
            const { data: response } = await axios.get("/reviews");
            putStorage("reviews", response || []);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("ko50dnhc1i"));
        }
    },

    createReview: async (data: any) => {
        try {
            const { data: response } = await axios.post("/reviews", { ...data });
            await ReviewsAPI.getAllReviews();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("q0q5kh2jc3"));
        }
    },

    updateReview: async (data: { id: string; [key: string]: any }) => {
        try {
            const { data: response } = await axios.put("/reviews", { ...data });
            await ReviewsAPI.getAllReviews();
            AlertsService.showSuccess(t("kiur5dwnpqf"));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("vmmgbc45mlk"));
        }
    },

    deleteReview: async (id: string) => {
        try {
            const { data: response } = await axios.delete(`/reviews/${id}`);
            await ReviewsAPI.getAllReviews();
            AlertsService.showSuccess(t("nmnr7bgqzhs"));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("873rga3gye5"));
        }
    },
};

export default ReviewsAPI;
